export interface PeriodsI {
  [key: string]: PeriodItemI;
}

export interface PeriodItemI {
  withinRange: boolean;
  startDate: string | null;
  endDate: string | null;
  currentUtcDate: string;
  type: PeriodItemITypeEnum;
}

export enum PeriodItemITypeEnum {
  RANGE = 'range',
  FROM = 'from',
  TO = 'to',
  NONE = 'none',
}
